import script from "./MainHead.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHead.vue?vue&type=script&setup=true&lang=js"

import "./MainHead.vue?vue&type=style&index=0&id=14fe5970&lang=scss"

const __exports__ = script;

export default __exports__